module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/top/logo_leaders04-a189f5a5c3df2e35135ff419654e9e69.svg";